import { render, staticRenderFns } from "./RolesCompany.vue?vue&type=template&id=ba1c3b78"
import script from "./RolesCompany.vue?vue&type=script&lang=js"
export * from "./RolesCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports